const routePaths = {
  HOME: {
    path: '/',
    title: 'Home',
  },
  CALENDAR: {
    path: '/calendar',
    title: 'Calendar',
  },
  AUDITS: {
    path: '/audits',
    title: 'Audits',
  },
  TASKS: {
    path: '/tasks',
    title: 'Tasks',
  },
  RISK_ENGINE: {
    path: '/risk-engine',
    title: 'Risk Engine',
  },
  REPORTS: {
    path: '/reports',
    title: 'Dashboard',
  },
  FEEDBACK: {
    path: '/feedback',
    title: 'Feedback',
  },
  TASK_DETAILS: {
    path: '/tasks/task-details',
    title: 'Task Details',
  },
  SETTINGS: {
    path: '/settings',
    title: 'Settings',
  },
  QUESTION: {
    path: '/question',
    title: 'Questions',
  },
  USERS: {
    path: '/settings/users',
    title: 'Users',
  },
  USERS_SERVER: {
    path: '/settings/users-server',
    title: 'Users',
  },
  NOTIFICATIONS: {
    path: '/notifications',
    title: 'Notifications',
  },
  LOCATIONS: {
    path: '/settings/locations',
    title: 'Locations',
  },
  TRANSLATIONS: {
    path: '/settings/translations',
    title: 'Translations',
  },
  BUSINESS_UNITS_DIVISIONS: {
    path: '/settings/business-divisions',
    title: 'Business & Divisions',
  },
  ROLES_PERMISSIONS: {
    path: '/settings/roles-permissions',
    title: 'Roles & Permissions',
  },
  TAGS: {
    path: '/settings/tags',
    title: 'Tags',
  },
  CATEGORIES: {
    path: '/settings/categories',
    title: 'Question Categories',
  },
  TEMPLATE: {
    path: '/settings/templates',
    title: 'Templates',
  },
  DASHBOARDS: {
    path: '/dashboards',
    title: 'dashboards',
  },
  PROFILE: {
    path: '/profile',
    title: 'profile',
  },
  PROFILE_PREFERENCES: {
    path: '/preferences',
    title: 'Profile Preferences',
  },
  SCHEDULES: {
    path: '/settings/schedules',
    title: 'Schedules',
  },
  CONFIGURATION: {
    path: '/settings/configuration',
    title: 'Division Configuration',
  },
  SCHEDULE_DETAILS: {
    path: '/settings/schedules/schedule-details',
    title: 'Schedule Details',
  },

  TEMPLATE_DETAILS: {
    path: '/settings/templates/template-details',
    title: 'Templates Details',
  },
  QUESTION_DETAILS: {
    path: '/question/question-details',
    title: 'Questions Details',
  },
  QUESTION_EDIT: {
    path: '/question/question-edit',
    title: 'Questions Edit',
  },
  GENERATE_QUESTIONS: {
    path: '/question/generate',
    title: 'Create Questions with Astra',
  },
  REVIEW_QUESTIONS: {
    path: '/question/generate/review',
    title: 'Review',
  },
  QUESTION_TRANSLATION_EDIT: {
    path: '/question/translation-edit',
    title: 'Translation Edit',
  },
  AUDIT_SUMMARY: {
    path: '/audits/audit-summary',
    title: 'Audit Summary ',
  },
  PERFORM_AUDIT: {
    path: '/audits/perform-audit',
    title: 'Perform Audit',
  },
} as const;

export default routePaths;
